export default __webpack_public_path__ + "static/media/paid-full.2409c437.png";